// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3ebGL","loaderOuter":"PageOverlayLoader_loaderOuter__14Yt2"};